// removed by extract-text-webpack-plugin
module.exports = {"navigationControls":"region-map-module__navigationControls___2wKUV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/region-map/region-map.module.scss
// module id = 626
// module chunks = 0 1